import { EntityStore } from '@monorepo/client-common';
import { getEnv } from '../../../helpers/mobx-easy-wrapper';
import SocialAccountService from '../../../services/entities/social-account-service';
import { SocialAccount } from '@monorepo/types';

export default class SocialAccountStore extends EntityStore<
  SocialAccountService,
  SocialAccount
> {
  constructor() {
    const {
      apiFactory: { socialAccountService },
    } = getEnv();

    super(socialAccountService);
  }

  async updateSocialAccountInfo(socialAccountId: string): Promise<boolean> {
    return this.service.updateSocialAccountInfo(socialAccountId);
  }

  async youtubeAuth(code: string): Promise<boolean> {
    return this.service.youtubeAuth(code);
  }

  async tiktokAuth(data: { code: string; state: string }): Promise<boolean> {
    return this.service.tiktokAuth(data);
  }

  async getTiktokUrl(): Promise<string> {
    return this.service.getTiktokAuthUrl();
  }

  async instagramAuth(data: { code: string; state: string }): Promise<boolean> {
    return this.service.instagramAuth(data);
  }

  async getInstagramUrl(): Promise<string> {
    return this.service.getInstagramAuthUrl();
  }

  async facebookAuth(data: { code: string; state: string }): Promise<boolean> {
    return this.service.facebookAuth(data);
  }

  async getFacebookUrl(): Promise<string> {
    return this.service.getFacebookAuthUrl();
  }
}
